import { masters } from "@nexseed/shared";
import { MailPlus } from "lucide-react";
import { defineMaster, type MasterRow } from "../spec";

/**
 * Who is copied on every arrival's Unloading Sheet e-mail (user, 2026-10-16), whatever the plant.
 * Switching a person off drops them from the next send; nothing is asked at send time.
 */
export const emailCc = defineMaster({
  key: "email-cc",
  title: "Unloading Sheet CC",
  singular: "CC recipient",
  legacyName: "Unloading Sheet CC",
  description: "Copied on every Unloading Sheet e-mail while Active.",
  icon: MailPlus,
  schema: masters.emailCc.create,
  searchPlaceholder: "Search name or e-mail",
  defaultSort: "name",
  optionLabel: (r: MasterRow) => String(r.name),
  columns: [
    { id: "name", header: "Name", sortable: true },
    { id: "email", header: "E-mail", sortable: true },
    { id: "isActive", header: "Status", kind: "status" },
  ],
  fields: [
    { name: "name", label: "Name", type: "text", required: true, colSpan: 2 },
    {
      name: "email",
      label: "E-mail",
      type: "text",
      required: true,
      colSpan: 2,
    },
    {
      name: "isActive",
      label: "Active",
      type: "switch",
      description: "Only Active people are copied",
    },
  ],
});
